import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const TrendFilterPage = lazyWithRetry(() => import('./pages/TrendFilterPage'))
const TrendHistoryPage = lazyWithRetry(() => import('./pages/TrendHistoryPage'))
const TrendRunPage = lazyWithRetry(() => import('./pages/TrendRunPage'))

const routes: AppRoute[] = [
  {
    path: 'trend-filter',
    children: [
      {
        index: true,
        element: TrendFilterPage,
        meta: {
          title: 'trendFilter.pageTitle',
          require: { minRole: ROLE.MEMBER },
        },
      },
      {
        path: 'history',
        element: TrendHistoryPage,
        meta: {
          title: 'trendFilter.history.title',
          require: { minRole: ROLE.MEMBER },
        },
      },
      {
        path: ':id',
        element: TrendRunPage,
        meta: {
          title: 'trendFilter.pageTitle',
          require: { minRole: ROLE.MEMBER },
        },
      },
    ],
  },
]

export default routes
